import { IAuthService } from '../auth/auth.service'
import { HttpClient, Options } from './standard.client'

export class StockopediaRestClient extends HttpClient {
  constructor(authService: IAuthService, baseUrl: string, options?: Options) {
    super(baseUrl, 'application/json', options)

    this.httpClient.interceptors.request.use(async (config) => {
      const token = await authService.getToken()
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }

      return config
    })
  }
}
